import { Observable } from 'rxjs';

import { ModuleQuestion } from 'module/page/question/module-question';

export abstract class ModuleQuestionRepositoryPort {
	public abstract observeModuleQuestionsByIds(
		questionsId: string[]
	): Observable<ModuleQuestion[]>;

	public abstract saveModuleQuestions(
		moduleQuestions: ModuleQuestion[]
	): Promise<void>;

	public abstract observeModuleQuestionById(
		questionId: string
	): Observable<ModuleQuestion>;
}
